const initialState = {
    list : [],
    loading : true,
    error: false,
};
function tokensReducer(state = initialState, action) {
    switch (action.type) {
        case 'LOAD_TOKENS':
            return { ...state, list:[], error: false, loading: true }
        case 'GET_TOKENS':
            return { ...state, list: action.payload, error: false, loading: false }
        case 'ERROR_TOKENS':
            return { ...state, list: [], error: true, loading: false }
        default:
            return state;
    }
};
export default tokensReducer;